import React, { useEffect } from "react";
import styled from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Intro = ({ timeline }) => {
  useEffect(() => {
    timeline.to(".text", {
      y: "0%",
      duration: 1,
      stagger: 0.25,
    });
    timeline.to(".slider", {
      y: "-100%",
      duration: 1.5,
      delay: 0.5,
    });
    timeline.to(
      ".intro",
      {
        y: "-100%",
        duration: 1,
      },
      "-=1.3"
    );
  }, []);

  return (
    <SectionIntro className="intro">
      <IntroText>
        <Hide>
          <Text className="text">Curieux</Text>
        </Hide>
        <Hide>
          <Text className="text">Créatif</Text>
        </Hide>
        <Hide>
          <Text className="text">Passionné</Text>
        </Hide>
      </IntroText>
      <Slider className="slider"></Slider>
    </SectionIntro>
  );
};

export default Intro;

const SectionIntro = styled.section`
  font-family: "Kaushan Script", sans serif;
  background-color: #000000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  overflow: hidden;
  touch-action: none;

  .text {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
`;

const IntroText = styled.div`
  color: ${(props) => props.theme.grey};
  font-family: "Courier New", Courier, monospace;
  font-size: 3rem;
`;

const Hide = styled.h1`
  overflow: hidden;
`;

const Text = styled.span`
  transform: translateY(100%);
  display: inline-block;

  @media (max-width: 48em) {
    font-size: ${(props) => props.theme.fontxs};
  }
 
`;

const Slider = styled.div`
  background-color: ${(props) => props.theme.grey};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: translateY(100%);
`;
